import { render, staticRenderFns } from "./OrderServiceList.vue?vue&type=template&id=6e1b012e&scoped=true"
import script from "./OrderServiceList.vue?vue&type=script&lang=js"
export * from "./OrderServiceList.vue?vue&type=script&lang=js"
import style0 from "./OrderServiceList.vue?vue&type=style&index=0&id=6e1b012e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b012e",
  null
  
)

export default component.exports